export default __webpack_public_path__ + "static/media/skirmishers_spellsword.af11173c.jpg";